import {useEffect, useState} from "react";
import {getComparePrompt, setComparePrompt} from "../../api/questionAPIs";
import {Button, TextareaAutosize, TextField} from "@mui/material";
import {useTranslation} from "react-i18next";

const ComparePromptEditComponent = ({intent}) => {
    const [t,] = useTranslation('global');
    const [enabled, setEnabled] = useState(false);
    const [prompt, setPrompt] = useState('');




    useEffect(() => {
        getCurrentPrompt();
    }, [intent]);

    const getCurrentPrompt = () => {
        const pr = getComparePrompt();
        pr.then((response) => {
            console.log('getComparePrompt result', response);
            setPrompt(response.Message);
        })
    }

    const onSave = () => {
        setComparePrompt(prompt);
        setEnabled(false);
    }

    return <div>
        <TextareaAutosize value={prompt} disabled={!enabled} className="compare-prompt-field"
            minRows={8} onChange={(e) => setPrompt(e.target.value)} />
        <div>
            {!enabled && <Button onClick={() => setEnabled(!enabled)}>{t(enabled ? 'disable' : 'enable')}</Button>}
            {enabled && <Button onClick={onSave}>{t('save')}</Button>}
            {enabled && <Button onClick={() => {
                getCurrentPrompt();
                setEnabled(false);
            }}>{t('cancel')}</Button>}
        </div>
    </div>
}

export default ComparePromptEditComponent;